import * as angular from "angular";
import { CanvasserTrackingDataProvider } from "../../data-provider/canvasser-tracking.dp";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { User } from "../../models/user.model";

let CanvasserTrackingMapComponent = {
    selector: "vcCanvasserTrackingMap",
    templateUrl:
        "/angular/components/canvasser-tracking/canvasser-tracking-map.component.html",
    bindings: {
        markers: "=",
        users: "=",
        inWidget: "=?",
    },
    controller: class CanvasserTrackingMapController {
        // * bindings for typescript compiler *
        private inWidget?: boolean;
        public users?: User[];
        public markers?: any[];
        // ************************************

        private showMap: boolean = false;
        private map: object;
        private markerEvents: object;

        private $scope: any;
        private $timeout: any;
        private uiGmapGoogleMapApi: any;
        private $location: any;
        private $anchorScroll: any;
        private dataProvider: CanvasserTrackingDataProvider;
        private activeCampaign: Campaign;
        public mapController: any;
        private stopMaxZoom = true;

        constructor(
            $scope: any,
            $timeout: any,
            uiGmapGoogleMapApi: any,
            $location: any,
            $anchorScroll: any,
            CanvasserTrackingDataProvider: CanvasserTrackingDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;
            this.dataProvider = CanvasserTrackingDataProvider;
            this.mapController = {};
            this.activeCampaign = CampaignDataProvider.activeCampaign;
            this.activeCampaign.getLocalStorage();

            this.markerEvents = {
                click: (marker: any, eventName: any, model: any, args: any) => {
                    if (!this.inWidget) {
                        if (model.id.includes("user")) {
                            this.$location.hash(
                                "user-" + model.id.replace("user", "")
                            );
                            this.$anchorScroll();
                            this.dataProvider.expandUser(
                                this.users,
                                this.markers,
                                model.id.replace("user", "")
                            );
                        } else if (model.id.includes("canvass")) {
                            this.dataProvider.selectedCanvassId =
                                model.id.replace("canvass", "");
                            this.$location.hash(
                                "canvass-" + model.id.replace("canvass", "")
                            );
                            this.$anchorScroll();
                        }
                    }
                },
                mouseover: (
                    marker: any,
                    eventName: any,
                    model: any,
                    args: any
                ) => {
                    if (!this.inWidget) {
                        if (model.id.includes("canvass")) {
                            this.dataProvider.expandCanvass(
                                this.markers,
                                model.id.replace("canvass", "")
                            );
                        }
                    }
                },
                mouseout: (
                    marker: any,
                    eventName: any,
                    model: object,
                    args: any
                ) => {
                    if (!this.inWidget) {
                        this.dataProvider.resetMarkers(this.markers);
                    }
                },
            };

            this.$scope.$watch(
                () => this.map,
                (newValue, oldValue) => {
                    if (
                        this.stopMaxZoom &&
                        newValue &&
                        oldValue &&
                        newValue["zoom"] &&
                        oldValue["zoom"] &&
                        newValue["zoom"] != oldValue["zoom"] &&
                        this.map["zoom"] > 20
                    ) {
                        this.map["zoom"] = 17;
                        this.stopMaxZoom = false;
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.markers,
                (newValue, oldValue) => {
                    this.stopMaxZoom = true;

                    if (!this.map) {
                        this.loadMap();

                        this.$timeout(() => {
                            this.showMap = true;
                        }, 200);
                    }
                },
                true
            );
        }

        loadMap(): void {
            this.uiGmapGoogleMapApi.then((map) => {
                this.map = {
                    center: this.activeCampaign.localInfo.map
                        ? this.activeCampaign.localInfo.map.center
                        : {
                              latitude: 20,
                              longitude: 4,
                          },
                    zoom: this.activeCampaign.localInfo.map ? 8 : 4,
                    control: {
                        disableDefaultUI: true,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        zoomControl: false,
                    },
                };
            });
        }
    },
};

angular
    .module("canvasserTracking")
    .component(
        CanvasserTrackingMapComponent.selector,
        CanvasserTrackingMapComponent
    );
